const envUrl = process.env.REACT_APP_BACKEND_URL;
let base = envUrl;

try {
  if (new URL(envUrl).host !== window.location.host) {
    base = window.location.origin;
  }
} catch {
  // keep env URL
}

export const API = `${base}/api`;
